var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("404")]),_c('h3',[_vm._v("La ruta a la que intenta acceder no pudo ser encontrada")])])}]

export { render, staticRenderFns }